/**
 * @flow
 */

/**
 * IntersectionObserver is not supported in JSDOM, can't really test it.
 *
 * TODO: Make a mock for it?
 */
/* istanbul ignore file */

import * as React from 'react';

type VisibilityTrackerProps = {|
    onContentVisible: Function,
    options?: IntersectionObserverOptions,
    elementRef: { current: any },
|};

export class VisibilityTracker extends React.Component<VisibilityTrackerProps> {
    static defaultProps = { onContentVisible: () => {} };

    constructor() {
        super();

        this.observer = null;
        this.handleIntersections = this.handleIntersections.bind(this);
    }

    componentDidMount() {
        this.initObserver();
    }

    componentDidUpdate() {
        if (!this.observer) {
            this.initObserver();
        }
    }

    componentWillUnmount() {
        this.disconnectObserver();
    }

    initObserver() {
        if (this.props.elementRef.current) {
            this.observer = new IntersectionObserver(
                this.handleIntersections,
                this.props.options || {}
            );
            this.observer.observe(this.props.elementRef.current);
        }
    }

    handleContentVisibility() {
        this.props.onContentVisible();
        this.disconnectObserver();
    }

    disconnectObserver() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    observer: ?IntersectionObserver;
    handleIntersections: Function;
    disconnectObserver: Function;

    handleIntersections(entries: [IntersectionObserverEntry]) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                this.handleContentVisibility();
            }
        });
    }

    render() {
        return null;
    }
}
